import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { Table, Row, Col, Card, CardBody, Spinner } from 'reactstrap';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component';

const ViewVendor = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all vendors (view_vendor)
  const get_list_handler = () => {
    setLoading(true);
    axios
      .get(mainurl + 'view_vendor')
      .then((response) => {
        console.log('View Vendor API Response:', response.data); // Log full API response

        const list = response.data.data.map((row, index) => {
          console.log('Phone No:', row?.phone_no); // Log phone_no here to inspect

          return {
            sl: index + 1,
            Vendor_Code: row?.vendor_code ?? '',
            Vendor_Name: row?.vendor_name ?? '',
            Ph_No: row?.ph_no ?? '', // Default value if phone_no is missing or empty
            GST_Number: row?.gst_no ?? 'N/A',
            ...row,
          };
        });

        setTableData(list);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error in View Vendor API:', error);
        setLoading(false);
        notification('error', 'Failed to fetch vendor data');
      });
  };

  useEffect(() => {
    get_list_handler();
  }, []);

  const custTableStyles = {
    rows: { highlightOnHover: true },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000',
        color: 'white',
      },
    },
    cells: { style: { padding: '10px' } },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-1">
            <Title pageTitle="View Vendors" />
          </Col>

          <Col xs={12}>
            <Card color="primary" outline>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <DataTable
                    customStyles={custTableStyles}
                    columns={[
                      { name: '#', selector: (row) => row.sl, width: '50px' },
                      { name: 'Vendor Code', selector: (row) => row.Vendor_Code },
                      { name: 'Vendor Name', selector: (row) => row.Vendor_Name },
                      { name: 'GST Number', selector: (row) => row.GST_Number },
                      { name: 'Phone No', selector: (row) => row.Ph_No }, // Displaying phone number here
                    ]}
                    data={tableData}
                    keyField="sl"
                    
                    progressPending={loading}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default ViewVendor;
